/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Failed_FallbackInputs */

const en_auth_failed_fallback = /** @type {(inputs: Auth_Failed_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication failed`)
};

const pt_br2_auth_failed_fallback = /** @type {(inputs: Auth_Failed_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na autenticação`)
};

/**
* | output |
* | --- |
* | "Authentication failed" |
*
* @param {Auth_Failed_FallbackInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_failed_fallback = /** @type {((inputs?: Auth_Failed_FallbackInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Failed_FallbackInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_failed_fallback(inputs)
	return pt_br2_auth_failed_fallback(inputs)
});